import { render, staticRenderFns } from "./ModalDivergenciaLocalidade.vue?vue&type=template&id=5f5ca83a&lang=pug"
import script from "./ModalDivergenciaLocalidade.vue?vue&type=script&lang=js"
export * from "./ModalDivergenciaLocalidade.vue?vue&type=script&lang=js"
import style0 from "./ModalDivergenciaLocalidade.vue?vue&type=style&index=0&id=5f5ca83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports